import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { SchoolMapItem } from '../../definitions/school-map-item';
import { MapItemComponent } from '@ui/shared/util-map';

import { DetailViewModule } from '@ui/shared/ui-detail-view';
import { SchoolMapItemFilteredMeasuresComponent } from '../school-map-item-filtered-measures/school-map-item-filtered-measures.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ui-school-map-item-popup-content',
    templateUrl: './school-map-item-popup-content.component.html',
    styleUrls: ['./school-map-item-popup-content.component.scss'],
    imports: [
        DetailViewModule,
        SchoolMapItemFilteredMeasuresComponent,
    ],
})
export class SchoolMapItemPopupContentComponent implements MapItemComponent<SchoolMapItem> {
    public mapItem = input<SchoolMapItem | undefined>();

    @Input()
    public isInSidebar = false;
}
